import { ContentType } from 'src/types/publishedAssets';

export function getInitialVisibleCount(metadata: ContentType['metadata'], fallback: number): number {
  if (typeof metadata?.initial_visible_count === 'number') {
    return metadata.initial_visible_count;
  }
  if (typeof metadata?.show_by_default === 'number') {
    return metadata.show_by_default;
  }
  return fallback;
}
